<div class="vendor-pricing-dialog">
  <header>
    <div class="header-left">
      <h2>Vendors and Costs</h2>
      <div *ngIf="accountName" class="account-name">{{accountName}}</div>
    </div>
    <div class="header-right">
      <div class="close" (click)="close()"></div>
    </div>
  </header>

  <div *ngIf="errors.length > 0" class="error-bar">
    <div *ngFor="let error of errors" class="error">{{error}}</div>
  </div>

  <div *ngIf="loading" class="loading">Loading . . .</div>
  <div *ngIf="loadError" class="error-bar"><div class="error">{{loadError}}</div></div>

  <section *ngIf="!loading && !loadError" class="body">

    <div class="vendor-table">
      <div class="table-header">
        <div class="col-vendor">Vendor</div>
        <div class="col-cost">Cost</div>
        <div class="col-remove"></div>
      </div>

      <div *ngIf="rows.length === 0" class="empty-state">
        No vendors yet. Search below to add the first one.
      </div>

      <div *ngFor="let row of rows" class="table-row" [class.removed]="row.removed" [class.new-row]="row.isNew">
        <div class="col-vendor">
          {{row.vendorName}}
          <span *ngIf="row.isNew" class="tag new">New</span>
          <span *ngIf="row.removed" class="tag removed-tag">Will be removed</span>
        </div>
        <div class="col-cost">
          <div class="cost-input" [class.invalid]="rowInvalid(row)">
            <span class="currency-symbol">$</span>
            <input type="number" step="0.01" min="0" [(ngModel)]="row.cost" [disabled]="row.removed"
                   [placeholder]="row.effectiveCost !== null ? ((row.effectiveCost / 100) | number:'1.2-2') : '0.00'" />
          </div>
          <div *ngIf="rowInvalid(row)" class="field-hint">Cost is required</div>
        </div>
        <div class="col-remove">
          <div class="remove-btn" [class.undo]="row.removed" (click)="removeRow(row)"
               [title]="row.removed ? 'Keep this vendor' : 'Remove this vendor'">
            <ng-container *ngIf="!row.removed">&#x2715;</ng-container>
            <ng-container *ngIf="row.removed">Undo</ng-container>
          </div>
        </div>
      </div>

      <div class="add-row">
        <div class="col-vendor">
          <input type="text" class="vendor-search" placeholder="Search vendors to add . . ."
                 [(ngModel)]="vendorSearchText" (ngModelChange)="searchVendors()" />
          <div *ngIf="vendorResults.length > 0" class="vendor-results">
            <div *ngFor="let vendor of vendorResults" class="vendor-result" (click)="addVendor(vendor)">
              {{vendor.name}}
            </div>
          </div>
        </div>
        <div class="col-cost"></div>
        <div class="col-remove"></div>
      </div>
    </div>

  </section>

  <footer *ngIf="!loading && !loadError">
    <button class="button" [disabled]="saving || !hasChanges()" (click)="save()">
      {{saving ? 'Saving . . .' : 'Save'}}
    </button>
  </footer>
</div>
